import React from 'react';
import PopupMask from "../PopupMask";
import Util from "../../public/utils";
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Col, Input, Modal, Row, Select } from "antd";
import styles from "../../common/templateMsg/template_msg.css";
import ColPicker from "../../colpicker";
import Vars from "../system_vars";
import MsgUtil from "../../ext/msg/msg_util";
import TaskposterUtil from "../../ext/taskpost/taskposter_util";
import MxdModal from "../modal";
import manageStyles from "../../common/templateMsg/msg_manage.css";
import MsgPreview from "../../common/templateMsg/msg_preview";
import {FetchUtil} from "../../public/fetch_util";
import {URL_TP_TEMPLATE_CHECK} from "../../public/variables";
import Message from "../ant/Message";
import '../rich_text_editor.css'
import './index.less'

const {Option} = Select;

class MsgTemplate extends React.Component {
    constructor(props) {
        super(props);
        this.recovery = this.recovery.bind(this);
        this.setKeyNote = this.setKeyNote.bind(this);
        this.colpick = this.colpick.bind(this);
        this.setMsgData = this.setMsgData.bind(this);
        this.linkChange = this.linkChange.bind(this);
        this.showPreview = this.showPreview.bind(this);
        this.mouseOverPhoneScroll = this.mouseOverPhoneScroll.bind(this);
        this.mouseLeavePhoneScroll = this.mouseLeavePhoneScroll.bind(this);
        this.showInsertTools = this.showInsertTools.bind(this);
        this.hideInsertTools = this.hideInsertTools.bind(this);
        this.editOnClick = this.editOnClick.bind(this);
        this.subsChange = this.subsChange.bind(this);
        this.cancel = this.cancel.bind(this);
        this.templateCheck = this.templateCheck.bind(this);
        this.checkSuccess = this.checkSuccess.bind(this);
        this.showNoTemplateSubs = this.showNoTemplateSubs.bind(this);
        this.noEnter = this.noEnter.bind(this);
        this.getId = this.getId.bind(this);
        this.insertNickName = this.insertNickName.bind(this);
        this.insertCompletedTaskNum = this.insertCompletedTaskNum.bind(this);
        this.insertUncompletedTaskNum = this.insertUncompletedTaskNum.bind(this);
        this.insertStockSurplus = this.insertStockSurplus.bind(this);
        this.insertTime = this.insertTime.bind(this);
        this.insertRedeemcode = this.insertRedeemcode.bind(this);
        this.insertHtmlCom = this.insertHtmlCom.bind(this);
        let varsStatus = {};
        if (props.vars) {
            for (var i = 0; i < props.vars.length; i++) {
                varsStatus[props.vars[i]] = true;
            }
        }
        this.state = {
            msg: null,
            keynote_list: [],
            varsStatus: varsStatus,
            linkType: {
                value: 0,
                text: '不跳转'
            },
            msgTemp: [],
            template_id: null
        }
    }

    componentDidMount() {
        this.initVars(this.props.vars);
        this.phoneScroll2 = Util.initScroll(this.refs.phoneScroll);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.renderTemp) {
            if (nextProps.msg) {
                this.setState({
                    template_id: nextProps.template_id,
                    msg: nextProps.msg
                });
                this.recovery(nextProps.msg);
                this.props.stopRender ? this.props.stopRender() : ''
            }
        }

        if (nextProps.vars && nextProps.vars != this.props.vars) {
            this.initVars(nextProps.vars);
            this.setState({})
        }
    }

    recovery(msg) {
        let id = this.getId();
        // 消息跳转
        var linkType = {
            value: 0,
            text: '不跳转'
        };
        if (msg.link && msg.link.type) {
            if (msg.link.type == 1) {
                linkType = {
                    value: 1,
                    text: '跳转到链接'
                };
                $("#url" + id).val(msg.link.url);
            }
            if (msg.link.type == 2) {
                linkType = {
                    value: 2,
                    text: '跳转到小程序'
                };
                $("#mappid" + id).val(msg.link.miniprogram.appid);
                $("#mpage" + id).val(msg.link.miniprogram.pagepath);
            }
            if (msg.link.type == 3) {
                linkType = {
                    value: 3,
                    text: '跳转到排行榜'
                }
            }
            if (msg.link.type == 4) {
                linkType = {
                    value: 4,
                    text: '跳转到关联表单'
                }
            }
        }


        this.setState({
            linkType: linkType,
        });

        this.setKeyNote(msg);
        this.setInnerHtml();
    }

    initVars(vars) {
        let varsStatus = {};
        if (vars) {
            for (var i = 0; i < vars.length; i++) {
                varsStatus[vars[i]] = true;
            }
        }
        this.setState({
            varsStatus: varsStatus,
        });
    }

    setInnerHtml() {
        let setMsgData = this.setMsgData;
        let id = this.getId();
        setTimeout(function () {
            $('#newTemplateMsg' + id + ' .insert-icon').tooltip();
            $("#newTemplateMsg" + id + " .rich-text-editor-content").on("input", function (e) {
                var value = TaskposterUtil.transformOutMsg(e.target);
                var key = e.target.getAttribute('data-key');
                setMsgData(key, value);
            });
        }, 200);
    }

    setKeyNote(msg) {
        let content = msg.content;
        let keynote_list = MsgUtil.getKeynoteList(content);
        let id = this.getId();

        for (var i = 0; i < keynote_list.length; i++) {
            if (keynote_list[i].key != 'url' && keynote_list[i].key != 'miniprogram') {
                keynote_list[i]['color'] = msg.data[keynote_list[i].key] ? msg.data[keynote_list[i].key].color : '#00000';
            }
            keynote_list[i]['rdn'] = Math.round(Math.random() * 10000);
        }
        this.setState({
            keynote_list: keynote_list
        });


        $('.rich-text-editor-content').html('');

        setTimeout(function () {
            for (var i = 0; i < keynote_list.length; i++) {
                if (keynote_list[i].key != 'url' && keynote_list[i].key != 'miniprogram') {
                    if (document.querySelector("#editor" + id + i)) {
                        TaskposterUtil.transformInMsg("editor" + id + i, msg.data[keynote_list[i].key] ? msg.data[keynote_list[i].key].value : '');
                    }
                }
            }
            if (msg.link.type == 1) {
                $("#url" + id).val(msg.link.url);
            }
            if (msg.link.type == 2) {
                $("#mappid" + id).val(msg.link.miniprogram.appid);
                $("#mpage" + id).val(msg.link.miniprogram.pagepath);
            }
        }, 200)
    }

    setMsgData(key, value) {
        if (key == 'first' || key == 'remark') {
            if (value.endsWith('\n')) {
                value = value.substring(0, value.length - 1);
            }
        } else {
            var re = new RegExp("\n", "g");
            value = value.replace(re, '');
        }
        var msg = this.state.msg;

        if (msg.data[key]) {
            msg.data[key].value = value;
        } else {
            let obj = {};
            obj.value = value;
            msg.data[key] = obj;
        }

        this.setState({
            msg: msg
        })
    }

    colpick(id, color) {
        var index = id.replace('colpick' + this.getId(), '');
        var msg = this.state.msg;
        var key = this.state.keynote_list[index].key;
        msg.data[key].color = color;
        this.setState({
            msg: msg
        });
    }

    showInsertTools(e) {
        var target = $(e.currentTarget);
        var tools = target.siblings('.rich-text-editor-tools');
        tools.removeClass('hide');
        target.addClass(styles.editWithTools);
    }

    editOnClick(e) {
        TaskposterUtil.textAreaClick(e);
        // this.msgScroll.disable();
    }

    hideInsertTools(e) {
        var target = $(e.currentTarget);
        var tools = target.siblings('.rich-text-editor-tools');
        tools.addClass('hide');
        target.removeClass(styles.editWithTools);
        // this.msgScroll.enable();
    }

    selectLinkType(data) {
        if (this.state.linkType.value != data.value) {
            var msg = this.state.msg;
            msg.url = '';
            msg.miniprogram = {};
            this.setState({
                msg: msg
            })
        }
        this.setState({
            linkType: data
        })
        if (data.value != 0) {
            // this.msgScroll.scrollTo(0, this.msgScroll.maxScrollY)
        }
    }

    linkChange(e) {
        var target = e.target;
        var key = target.getAttribute('data-key');
        var value = target.value;
        var msg = this.state.msg;
        if (key == 'url') {
            if (value && value.indexOf("http://") < 0 && value.indexOf('https://') < 0) {
                msg.url = 'http://' + value;
            } else {
                msg.url = value;
            }
        } else if (key == 'miniprogram') {
            var id = target.getAttribute('id');
            if (id == ('mappid' + this.props.id)) {
                msg.miniprogram['appid'] = value;
            } else {
                msg.miniprogram['pagepath'] = value;
            }
        }
        this.setState({
            msg: msg
        })
    }

    insertNickName(e) {
        e.stopPropagation();
        TaskposterUtil.insertNickName(e);
        var key = e.target.getAttribute('data-key');
        var index = e.target.getAttribute('index');
        var value = TaskposterUtil.transformOutMsg(document.querySelector("#editor" + this.props.id + index));
        this.setMsgData(key, value);
    }

    insertGiftBagName(e) {
        e.stopPropagation();
        TaskposterUtil.insertGiftBagName(e);
        var key = e.target.getAttribute('data-key');
        var index = e.target.getAttribute('index');
        var value = TaskposterUtil.transformOutMsg(document.querySelector("#editor" + this.props.id + index));
        this.setMsgData(key, value);
    }

    insertBoostName(e) {
        e.stopPropagation();
        TaskposterUtil.insertBoostName(e);
        var key = e.target.getAttribute('data-key');
        var index = e.target.getAttribute('index');
        var value = TaskposterUtil.transformOutMsg(document.querySelector("#editor" + this.props.id + index));
        this.setMsgData(key, value);
    }

    insertCompletedTaskNum(e) {
        TaskposterUtil.insertCompletedTaskNum(e);
        var key = e.target.getAttribute('data-key');
        var index = e.target.getAttribute('index');
        var value = TaskposterUtil.transformOutMsg(document.querySelector("#editor" + this.props.id + index));
        this.setMsgData(key, value);
    }

    insertUncompletedTaskNum(e) {
        TaskposterUtil.insertUncompletedTaskNum(e);
        var key = e.target.getAttribute('data-key');
        var index = e.target.getAttribute('index');
        var value = TaskposterUtil.transformOutMsg(document.querySelector("#editor" + this.props.id + index));
        this.setMsgData(key, value);
    }

    insertStockSurplus(e) {
        TaskposterUtil.insertStockSurplus(e);
        var key = e.target.getAttribute('data-key');
        var index = e.target.getAttribute('index');
        var value = TaskposterUtil.transformOutMsg(document.querySelector("#editor" + this.props.id + index));
        this.setMsgData(key, value);
    }

    insertTime(e) {
        TaskposterUtil.insertTime(e);
        var key = e.target.getAttribute('data-key');
        var index = e.target.getAttribute('index');
        var value = TaskposterUtil.transformOutMsg(document.querySelector("#editor" + this.props.id + index));
        this.setMsgData(key, value);
    }

    insertRedeemcode(e) {
        TaskposterUtil.insertRedeemcode(e);
        var key = e.target.getAttribute('data-key');
        var index = e.target.getAttribute('index');
        var value = TaskposterUtil.transformOutMsg(document.querySelector("#editor" + this.props.id + index));
        this.setMsgData(key, value);
    }

    insertHtmlCom(type, e) {
        TaskposterUtil.insertFormCom(type, e);
        var key = e.target.getAttribute('data-key');
        var index = e.target.getAttribute('index');
        var value = TaskposterUtil.transformOutMsg(document.querySelector("#editor" + this.props.id + index));
        this.setMsgData(key, value);
    }

    showPreview() {
        MxdModal.show("#msgPreview" + this.props.id);
        this.phoneScroll2.refresh();
    }

    mouseOverPhoneScroll() {
        // this.msgScroll.disable();
    }

    mouseLeavePhoneScroll() {
        // this.msgScroll.enable();
    }

    subsChange(index) {
        this.setState({
            currentSubsIndex: index
        })
    }

    cancel() {
        if (this.state.step == 1) {
            this.setCreateMsgModalVisible(false);
        } else {
            this.setState({
                step: 1
            })
        }
    }

    preventHideTools(e) {
        e.preventDefault();
    }

    templateCheck(currentMsg) {
        let subsList = currentMsg.subsList;
        if (subsList && subsList.length > 0) {
            let fetchUtil = new FetchUtil();
            fetchUtil.init()
                .setUrl(URL_TP_TEMPLATE_CHECK)
                .setMethod('POST')
                .setCookieCors()
                .setBodyType('json')
                .setBody({
                    msg: {
                        content: currentMsg.msg.content
                    },
                    subsList: currentMsg.subsList
                })
                .dofetch()
                .then((msg) => {
                    if (msg.respCode == 0) {
                        let subsList = msg.respMsg.subsList;
                        let notempleteSubs = [];
                        for (let i = 0; i < subsList.length; i++) {
                            if (Util.isNull(subsList[i].templateId)) {
                                notempleteSubs.push(subsList[i].appId);
                            }
                        }
                        if (notempleteSubs.length > 0) {
                            this.showNoTemplateSubs(notempleteSubs)
                        } else {
                            currentMsg.subsList = subsList;
                            this.checkSuccess(currentMsg);
                        }
                    } else {
                        Message.warning("系统错误，请稍后再试")
                    }
                })
                .catch((err) => {
                    Message.warning("系统错误，请稍后再试")
                })
        } else {
            this.checkSuccess(currentMsg)
        }
    }

    checkSuccess(currentMsg) {
        this.setState({
            currentMsg: currentMsg,
            noTemplateSubsTip: ''
        });
        if (this.props.onChange) {
            this.props.onChange(currentMsg);

        }
        this.setCreateMsgModalVisible(false);
    }

    showNoTemplateSubs(notempleteSubs) {
        let tip = '公众号';
        for (let i = 0; i < notempleteSubs.length; i++) {
            for (let m = 0; m < this.state.subs.length; m++) {
                if (this.state.subs[m].appId == notempleteSubs[i]) {
                    tip += this.state.subs[m].nickName + '、';
                }
            }
        }
        tip = tip.substring(0, tip.length - 1);
        tip += '没有该消息模板';
        this.setState({
            noTemplateSubsTip: tip
        })
    }

    noEnter(e) {
        if (e.charCode === 13) {
            e.preventDefault();
        }
    }


    getId() {
        return this.props.id;
    }

    getLinkCon() {
        let msg = this.state.msg;
        let type = this.state.linkType.value;

        var linkType = {
            value: 0,
            text: '不跳转'
        };
        if (type == 1) {
            linkType = {
                type: 1,
                text: '跳转到链接',
                url: msg.url
            };
        }
        if (type == 2) {
            linkType = {
                type: 2,
                text: '跳转到小程序',
                miniprogram: msg.miniprogram
            };
        }
        if (type == 3) {
            linkType = {
                type: 3,
                text: '跳转到排行榜'
            }
        }
        if (type == 4) {
            linkType = {
                type: 4,
                text: '跳转到关联表单'
            }
        }

        return linkType;
    }

    getData() {

        let subsListArr = [];
        let subsListObj = {
            templateId: this.state.template_id,
            appId: this.props.appId
        };
        let msg = this.state.msg;
        let linkType = this.getLinkCon();
        msg.link = linkType;
        subsListArr.push(subsListObj);
        // let data = {
        //     subsList: subsListArr,
        //     msg: this.state.msg
        // };
        let data = this.state.msg;
        return data
    }

    render() {
        var colpick = this.colpick;
        var showInsertTools = this.showInsertTools;
        var hideInsertTools = this.hideInsertTools;
        var selectLinkType = this.selectLinkType;
        var varsStatus = this.state.varsStatus;
        var linkChange = this.linkChange;
        var insertNickName = this.insertNickName;
        var insertGiftBagName = this.insertGiftBagName;
        var insertBoostName = this.insertBoostName;
        var insertCompletedTaskNum = this.insertCompletedTaskNum;
        var insertUncompletedTaskNum = this.insertUncompletedTaskNum;
        var insertStockSurplus = this.insertStockSurplus;
        var insertRedeemcode = this.insertRedeemcode;
        var insertTime = this.insertTime;
        var noEnter = this.noEnter;
        var editOnClick = this.editOnClick;
        var mouseLeavePhoneScroll = this.mouseLeavePhoneScroll;
        let preventHideTools = this.preventHideTools;

        var id = this.getId();
        return (
            <div id={'newTemplateMsg' + this.getId()} className={'mxd-msg-template'}>
                <div>
                    <Row gutter={100}>
                        <Col span={13}>
                            <div>
                                {
                                    this.props.children ? this.props.children : ''
                                }

                                {
                                    this.state.keynote_list.map((data, i) => {
                                        if (data.key != 'miniprogram' && data.key != 'url') {
                                            return (
                                                <Row gutter={20} key={i}>
                                                    <Col span={6} align="right">
                                                        <label>{data.word}</label>
                                                    </Col>
                                                    <Col span={18}>
                                                        <div className={styles.msgColBox}><ColPicker
                                                            id={"colpick" + id + i}
                                                            key={data.rdn}
                                                            onChange={colpick}
                                                            color={data.color ? data.color : '#000000'}/>
                                                        </div>
                                                        <div className={styles.inputContainer}>
                                                            <div className={styles.editorWrapper}>
                                                                <div
                                                                    className={"rich-text-editor-tools hide " + styles.editorTools}
                                                                    onMouseDown={preventHideTools}>
                                                                    {
                                                                        varsStatus[Vars.NICKNAME()] ?
                                                                            <span
                                                                                className="insert-icon icon-nickname"
                                                                                title="插入昵称"
                                                                                data-key={data.key}
                                                                                index={i}
                                                                                onClick={insertNickName}></span> : ''
                                                                    }
                                                                    {
                                                                        varsStatus[Vars.BOOST_NAME()] ?
                                                                            <span
                                                                                className="insert-icon icon-goods-name"
                                                                                title="插入活动名称"
                                                                                data-key={data.key}
                                                                                index={i}
                                                                                onClick={this.insertHtmlCom.bind(this, 'BOOST_NAME')}></span> : ''
                                                                                // onClick={insertBoostName}></span> : ''
                                                                    }
                                                                    {
                                                                        varsStatus[Vars.GIFTBAG_NAME()] ?
                                                                            <span
                                                                                className="insert-icon icon-goods-name"
                                                                                title="插入礼包名称"
                                                                                data-key={data.key}
                                                                                index={i}
                                                                                onClick={this.insertHtmlCom.bind(this, 'GIFTBAG_NAME')}></span> : ''
                                                                    }
                                                                    {
                                                                        varsStatus[Vars.COMPLETED_TASK_NUM()] ?
                                                                            <span
                                                                                className="insert-icon icon-complete"
                                                                                title="插入已完成任务量"
                                                                                data-key={data.key}
                                                                                index={i}
                                                                                onClick={insertCompletedTaskNum}></span> : ''
                                                                    }
                                                                    {
                                                                        varsStatus[Vars.UNCOMPLETED_TASK_NUM()] ?
                                                                            <span
                                                                                className="insert-icon icon-uncomplete"
                                                                                title="插入未完成任务量"
                                                                                data-key={data.key}
                                                                                index={i}
                                                                                onClick={insertUncompletedTaskNum}></span> : ''
                                                                    }
                                                                    {
                                                                        varsStatus[Vars.STOCKSURPLUS()] ?
                                                                            <span
                                                                                className="insert-icon icon-stock"
                                                                                title="插入一阶任务库存剩余"
                                                                                data-key={data.key}
                                                                                index={i}
                                                                                onClick={insertStockSurplus}></span> : ''
                                                                    }
                                                                    {
                                                                        varsStatus[Vars.TIME()] ?
                                                                            <span
                                                                                className="insert-icon icon-time"
                                                                                title="插入粉丝收到消息时的当前时间"
                                                                                data-key={data.key}
                                                                                index={i}
                                                                                onClick={insertTime}></span> : ''
                                                                    }
                                                                    {
                                                                        varsStatus[Vars.REDEEMCODE()] ?
                                                                            <span
                                                                                className="insert-icon icon-redeemcode"
                                                                                title="插入兑换码"
                                                                                data-key={data.key}
                                                                                index={i}
                                                                                onClick={insertRedeemcode}></span> : ''
                                                                    }
                                                                    {
                                                                        varsStatus[Vars.GOODS_NAME()] ?
                                                                            <span
                                                                                className="insert-icon icon-goods-name"
                                                                                title="插入商品名称"
                                                                                data-key={data.key}
                                                                                index={i}
                                                                                onClick={this.insertHtmlCom.bind(this, 'GOODS_NAME')}></span> : ''
                                                                    }
                                                                    {
                                                                        varsStatus[Vars.DATETIME()] ?
                                                                            <span
                                                                                className="insert-icon icon-datetime"
                                                                                title="插入当前时间"
                                                                                data-key={data.key}
                                                                                index={i}
                                                                                onClick={this.insertHtmlCom.bind(this, 'DATETIME')}></span> : ''
                                                                    }
                                                                    {
                                                                        varsStatus[Vars.GOODS_AMOUNT()] ?
                                                                            <span
                                                                                className="insert-icon icon-goods-amount"
                                                                                title="插入商品价格"
                                                                                data-key={data.key}
                                                                                index={i}
                                                                                onClick={this.insertHtmlCom.bind(this, 'GOODS_AMOUNT')}></span> : ''
                                                                    }
                                                                    {
                                                                        varsStatus[Vars.GROUP_NUM()] ?
                                                                            <span
                                                                                className="insert-icon icon-group-num"
                                                                                title="插入拼团人数"
                                                                                data-key={data.key}
                                                                                index={i}
                                                                                onClick={this.insertHtmlCom.bind(this, 'GROUP_NUM')}></span> : ''
                                                                    }
                                                                    {
                                                                        varsStatus[Vars.GROUP_LIMITEDTIME()] ?
                                                                            <span
                                                                                className="insert-icon icon-goods-limiteditime"
                                                                                title="插入拼团限制时间"
                                                                                data-key={data.key}
                                                                                index={i}
                                                                                onClick={this.insertHtmlCom.bind(this, 'GROUP_LIMITEDTIME')}></span> : ''
                                                                    }
                                                                    {
                                                                        varsStatus[Vars.GROUP_ENDDATE()] ?
                                                                            <span
                                                                                className="insert-icon icon-group-enddate"
                                                                                title="插入拼团截止时间"
                                                                                data-key={data.key}
                                                                                index={i}
                                                                                onClick={this.insertHtmlCom.bind(this, 'GROUP_ENDDATE')}></span> : ''
                                                                    }
                                                                    {
                                                                        varsStatus[Vars.GROUP_BEGINDATE()] ?
                                                                            <span
                                                                                className="insert-icon icon-group-begindate"
                                                                                title="插入拼团开始时间"
                                                                                data-key={data.key}
                                                                                index={i}
                                                                                onClick={this.insertHtmlCom.bind(this, 'GROUP_BEGINDATE')}></span> : ''
                                                                    }
                                                                    {
                                                                        varsStatus[Vars.FROM_NICKNAME()] ?
                                                                            <span
                                                                                className="insert-icon icon-from-nickname"
                                                                                title="插入好友昵称"
                                                                                data-key={data.key}
                                                                                index={i}
                                                                                onClick={this.insertHtmlCom.bind(this, 'FROM_NICKNAME')}></span> : ''
                                                                    }
                                                                    {
                                                                        varsStatus[Vars.GROUP_PART_NUM()] ?
                                                                            <span
                                                                                className="insert-icon icon-group-part-num"
                                                                                title="插入已参团人数"
                                                                                data-key={data.key}
                                                                                index={i}
                                                                                onClick={this.insertHtmlCom.bind(this, 'GROUP_PART_NUM')}></span> : ''
                                                                    }
                                                                    {
                                                                        varsStatus[Vars.GROUP_CREATER()] ?
                                                                            <span
                                                                                className="insert-icon icon-group-creater"
                                                                                title="插入团长昵称"
                                                                                data-key={data.key}

                                                                                index={i}
                                                                                onClick={this.insertHtmlCom.bind(this, 'GROUP_CREATER')}></span> : ''
                                                                    }
                                                                    {
                                                                        varsStatus[Vars.RETURN_AMOUNT()] ?
                                                                            <span
                                                                                className="insert-icon icon-return-amount"
                                                                                title="插入返现金额"
                                                                                data-key={data.key}
                                                                                index={i}
                                                                                onClick={this.insertHtmlCom.bind(this, 'RETURN_AMOUNT')}></span> : ''
                                                                    }
                                                                    {
                                                                        varsStatus[Vars.TALLIESDESC()] ?
                                                                            <span
                                                                                className="insert-icon icon-talliesdesc"
                                                                                title="插入奖励金入账说明"
                                                                                data-key={data.key}
                                                                                index={i}
                                                                                onClick={this.insertHtmlCom.bind(this, 'TALLIESDESC')}></span> : ''
                                                                    }
                                                                </div>
                                                                <div id={"editor" + id + i}
                                                                     data-key={data.key}
                                                                     onFocus={showInsertTools}
                                                                     onBlur={hideInsertTools}
                                                                     onClick={editOnClick}
                                                                     className={"rich-text-editor-content text editable " + styles.editorContent + ((data.key == 'first' || data.key == 'remark') ? ' ' + styles.editorContentArea : '')}
                                                                     onKeyPress={((data.key == 'first' || data.key == 'remark') ? '' : noEnter)}
                                                                     onMouseLeave={mouseLeavePhoneScroll}
                                                                     contentEditable="true"
                                                                     placeholder={data.key + ".DATA"}>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            )
                                        }
                                    })
                                }
                                {
                                    this.state.keynote_list && this.state.keynote_list.length > 0 ?
                                        <div className={'hide'}>
                                            <Row gutter={32}>
                                                <Col span={6} align="right">
                                                    <label>点击消息</label>
                                                </Col>
                                                <Col span={18}>
                                                    <div className={styles.inputContainer}>
                                            <span className="dropup mxd-dropdown-select" onMouseDown={preventHideTools}>
                                            <span className={"dropdown-toggle " + styles.dropdownToggle}
                                                  data-toggle="dropdown" role="button"
                                                  aria-haspopup="true" aria-expanded="false">
                                                 <span>{this.state.linkType.text}</span>
                                                 <span className="mxd-caret-thin"></span>
                                            </span>
                                            <ul className="mxd-dropdown-menu dropdown-menu">
                                                <li><a className="menu-item-xs" onClick={selectLinkType.bind(this, {
                                                    value: 0,
                                                    text: '不跳转'
                                                })}>不跳转</a></li>
                                                <li><a className="menu-item-xs" onClick={selectLinkType.bind(this, {
                                                    value: 1,
                                                    text: '跳转到链接'
                                                })}>跳转到链接</a></li>
                                                <li><a className="menu-item-xs" onClick={selectLinkType.bind(this, {
                                                    value: 2,
                                                    text: '跳转到小程序'
                                                })}>跳转到小程序</a></li>
                                                <li><a className="menu-item-xs" onClick={selectLinkType.bind(this, {
                                                    value: 3,
                                                    text: '跳转到排行榜'
                                                })}>跳转到排行榜</a></li>
                                                {
                                                    this.state.bindForm ?
                                                        <li>
                                                            <a className="menu-item-xs"
                                                               onClick={selectLinkType.bind(this, {
                                                                   value: 4,
                                                                   text: '跳转到关联表单'
                                                               })}>跳转到关联表单</a>
                                                        </li> : ''
                                                }
                                            </ul>
                                        </span>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <div className={styles.linkGroup}>
                                                {
                                                    this.state.linkType.value == 1 ?
                                                        <Row gutter={32}>
                                                            <Col offset={6}>
                                                                <div className={styles.inputContainer}>
                                                                    <Input id={"url" + this.props.id}
                                                                           type="text"
                                                                           className="msgInput"
                                                                           placeholder="http://或https://开头"
                                                                           data-key="url"
                                                                           onChange={linkChange}/>
                                                                </div>
                                                            </Col>
                                                        </Row> : ''
                                                }
                                                {
                                                    this.state.linkType.value == 2 ? <div>
                                                        <Row gutter={32}>
                                                            <div className={styles.inputContainer}>
                                                                <Col offset={6}>
                                                                    <Input id={"mappid" + this.props.id}
                                                                           type="text"
                                                                           className="msgInput"
                                                                           placeholder="小程序appid"
                                                                           data-key="miniprogram"
                                                                           onChange={linkChange}/>
                                                                </Col>
                                                            </div>
                                                        </Row>
                                                        <Row gutter={32}>
                                                            <div className={styles.inputContainer}>
                                                                <Col offset={6}>
                                                                    <Input id={"mpage" + this.props.id}
                                                                           type="text"
                                                                           className="msgInput"
                                                                           placeholder="小程序跳转地址"
                                                                           data-key="miniprogram"
                                                                           onChange={linkChange}/>
                                                                </Col>
                                                            </div>
                                                        </Row>
                                                    </div> : ''
                                                }
                                                {
                                                    this.state.linkType.value == 3 ?
                                                        <Row gutter={32}>
                                                            <Col offset={6}>
                                                                排行榜链接后台自动绑定，不需要设置
                                                            </Col>
                                                        </Row> : ''
                                                }
                                            </div>
                                        </div> : ''
                                }
                            </div>
                            {
                                this.state.noTemplateSubsTip ? <div>
                                        <span className="tp-autoclose-des"><ExclamationCircleOutlined />{this.state.noTemplateSubsTip}
                                        </span>
                                    &nbsp;&nbsp;&nbsp;<a href="https://shimo.im/docs/C6g2MwfXSIo7JhEW/read"
                                                         target="_blank">如何添加相同模板？</a>
                                </div> : ''
                            }
                        </Col>
                        <Col span={11}>
                            <div className={manageStyles.phonebg}>
                                <div className={manageStyles.phoneScroll} ref="phoneScroll"
                                     onMouseOver={this.mouseOverPhoneScroll}
                                     onMouseLeave={this.mouseLeavePhoneScroll}>
                                    <div className={manageStyles.phoneContent}>
                                        {
                                            this.state.msg ?
                                                <MsgPreview key="2" msg={this.state.msg}
                                                            preview="true"/> : ''
                                        }
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}

export default MsgTemplate;